import React from "react";
import Nav from "react-bootstrap/Nav";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import _ from "underscore";
import config from "../../../config";
import {Button} from "react-bootstrap";
import {generateCollectionPrefix, generateCollections} from "../helpers";

const TwoLevelsMenuOthers = (
    {
        menu_key, eventKey, setEventKey, showHideMenus,
        twoLevelsMenuRef, designers, bc_filter_tree
    }
) => {
    const header_menu_item_options = _.find(config.header_menu_items, (header_menu_item) => {
        return menu_key === header_menu_item.key;
    });
    const collections_info = header_menu_item_options.collections_info;
    const designers_list = header_menu_item_options.manual_designers_list || designers;

    const collections = generateCollections(header_menu_item_options, bc_filter_tree);
    const collections_prefix = generateCollectionPrefix(collections);

    return (
        <div className="sidebar-menu-nav__submenu" ref={twoLevelsMenuRef} tabIndex="0">
            <div className="sidebar-menu-nav__submenu-button-container">
                <Nav.Item
                    as="button"
                    onClick={showHideMenus}
                    className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--back-container"
                >
                    <span className="icon-arrow-left sidebar-menu-nav__top-item--back"/>
                    Menu
                </Nav.Item>
            </div>
            <div className="clearfix"/>
            <Nav.Item as="span" className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--top sidebar-menu-nav__top-item--title">
                {header_menu_item_options.title}
                <Button
                    href={header_menu_item_options.href}
                    variant="clean"
                    className="sidebar-menu-nav__mobile-all-category-btn"
                >
                    View All
                    <span className="icon-arrow-right sidebar-menu-nav__mobile-all-category-icon"/>
                </Button>
            </Nav.Item>
            <Accordion defaultActiveKey={header_menu_item_options.mobile_submenu_open_by_default}>
                {collections && collections.values.length > 0 && <Card>
                    <div className="sidebar-menu-nav__submenu-button-container">
                        <Accordion.Toggle
                            as="button"
                            className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--no-margin"
                            eventKey="0"
                            onClick={() => setEventKey(eventKey === "0" ? null : "0")}
                        >
                            {collections.label.replace(" Hidden","")}
                            <span className={`icon-${eventKey === "0" ? "minus" : "plus"}`}/>
                        </Accordion.Toggle>
                    </div>
                    <Accordion.Collapse eventKey="0">
                        <div className="side-menu">
                            {_.map(_.sortBy(collections.values, "key"), (collection, idx) => {
                                return (
                                    <Card.Link
                                        key={idx}
                                        href={`${header_menu_item_options.href}&sort=created-descending&${header_menu_item_options.collections_filter_key}=${collection.key}`}
                                    >
                                        {collection.key.replace(collections_prefix, "")}
                                    </Card.Link>
                                );
                            })}
                        </div>
                    </Accordion.Collapse>
                </Card>}
                {!_.isEmpty(collections_info) && <Card>
                    <div className="sidebar-menu-nav__submenu-button-container">
                        <Accordion.Toggle
                            as="button"
                            className="sidebar-menu-nav__top-item sidebar-menu-nav__top-item--no-margin"
                            eventKey="1"
                            onClick={() => setEventKey(eventKey === "1" ? null : "1")}
                        >
                            {collections_info.title}
                            <span className={`icon-${eventKey === "1" ? "minus" : "plus"}`}/>
                        </Accordion.Toggle>
                    </div>
                    <Accordion.Collapse eventKey="1">
                        <div className="side-menu">
                            {_.map(designers_list, (designer, idx) => {
                                return (
                                    <Card.Link
                                        key={designer.id || idx}
                                        href={`${header_menu_item_options.href}&${header_menu_item_options.other_filter_key}=${encodeURIComponent(designer.name)}`}
                                    >
                                        {designer.name}
                                        {designer.is_new === true && <span className="top-nav__new-label">New</span>}
                                    </Card.Link>
                                );
                            })}
                        </div>
                    </Accordion.Collapse>
                </Card>}
            </Accordion>
        </div>
    );
}

export default TwoLevelsMenuOthers;